const pluralize = (count, entityName) => {
  if (count === 1) {
    return entityName;
  }
  return `${entityName}s`;
};

/**
 * DEPRECATED: This implementation does not allow for proper grammar and extensibility
 * Reference: https://agile.8x8.com/browse/TAP-2389
 */
export const createNotifier =
  (operationName, entityName) => (successfulMutationCount, mutationCount) =>
    `${successfulMutationCount}/${mutationCount} ${pluralize(
      mutationCount,
      entityName
    )} ${operationName}d`;

/**
 * TODO: This should be modified because the name is misleading.
 * TODO: It is a way to create notification text content, not a "notifier" specifically
 *
 * Generates a message appropriate for a notification using the given details
 *
 * @param operation The description of the operation involved
 * @param singular The way to express that only 1 item was involved in the operation
 * @param plural The way to express that more than 1 item was involved in the operation
 * @example This will produce a message "1 bus pulled into the station" or "X buses pulled into the station"
 * createCustomNotifier("pulled into the station", "bus", "buses")
 * @returns A function which when called with the successful and total counts, will return the desired notification message
 */
export const createCustomNotifier =
  ({ operation, singular, plural }) =>
  (successfulMutationCount, mutationCount) =>
    `${successfulMutationCount} ${
      mutationCount === 1 ? singular : plural
    } ${operation}`;
